import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';

const useTimer = (config, timezone) => {
  const {
    countdownType,
    countdownDate,
    countdownDay,
    countdownTime = 0,
  } = config;
  const [values, setValues] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    if (config) {
      const tz = timezone || 'America/Chicago';
      let eventDate;
      if (countdownType === 'fixed' && countdownDate) {
        eventDate = moment.utc(countdownDate).tz(tz);
      } else if (countdownType === 'recurring' && countdownDay) {
        eventDate = moment
          .tz(tz)
          .startOf('day')
          .day(countdownDay)
          .minute(countdownTime);
        const now = moment.tz(tz);
        if (now.isAfter(eventDate)) {
          eventDate.add(1, 'week');
        }
      }
      const interval = setInterval(() => {
        const now = moment.tz(tz);
        if (!eventDate || now.isAfter(eventDate)) {
          clearInterval(interval);
          setValues({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          });
          return;
        }
        const days = eventDate.diff(now, 'days');
        const hours = eventDate.diff(now, 'hours') - days * 24;
        const minutes =
          eventDate.diff(now, 'minutes') - days * 24 * 60 - hours * 60;
        const seconds =
          eventDate.diff(now, 'seconds') -
          days * 24 * 60 * 60 -
          hours * 60 * 60 -
          minutes * 60;
        setValues({
          days,
          hours,
          minutes,
          seconds,
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [countdownType, countdownDate, countdownDay, countdownTime]);
  return values;
};

export default useTimer;
